// Se o plano do cliente logado enxerga sugestões de conteúdo.
//
// Mesma mecânica da flag de plano de comunicação (`plano-comunicacao.js`): a role
// `LerMinhasSugestoes` é igual para todo cliente, quem separa é o plano — então o menu e o
// guard de rota precisam da resposta de forma síncrona, sem ter um endpoint próprio para
// consultar. A flag vem do backend (login e status do plano na home) e fica em cache.
//
// Enquanto não se sabe, vale `true`: é como todo plano se comportava antes, então um cliente
// de plano regular nunca perde as sugestões por causa de cache frio — nem quando o backend
// ainda não manda a flag.
const STORAGE_KEY = "mention.exibeSugestoesConteudo";

export const setExibeSugestoesConteudo = (valor) => {
  if (valor === undefined || valor === null) return;
  localStorage.setItem(STORAGE_KEY, valor ? "1" : "0");
};

export const exibeSugestoesConteudo = () => localStorage.getItem(STORAGE_KEY) !== "0";
